import React, { useEffect } from "react";
import "grapesjs/dist/css/grapes.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";

import { Route, Routes, Navigate } from "react-router-dom";
import MainLayout from "./components/mainLayout";
import LoginPage from "./pages/loginPage";
import RegisterPage from "./pages/registerPage";
import Dashboard from "./pages/dashboard";
import BadgeEditor from "./pages/badgeEditor";
import CategoryManagement from "./pages/categoryManagement";
import UserManagement from "./pages/userManagement";
import BadgePreview from "./pages/badgePreview";
import BadgeEdit from "./pages/badgeEdit";
import ChecklistPage from "./pages/checklistPage";
import InfoMessage from "./pages/infoMessage";
import ForgotPassword from "./pages/forgotPassword";
import NotificationsPage from "./pages/notifications";
import { useDispatch } from 'react-redux';
import { initializeAuth } from './features/authSlice';
import LandingEditor from "./pages/landingEditor";
import LandingEditorDesktop from "./pages/landingEditorDesktop";
import FanTemplate from "./pages/fanTemplate";
import KeyManagement from "./pages/KeyManagement";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  return (
    <div>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        {
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />}>
              {" "}
            </Route>
            <Route path="/badge-editor" element={<BadgeEditor />}>
              {" "}
            </Route>
            <Route path="/landing-editor" element={<LandingEditor />}>
              {" "}
            </Route>
            <Route path="/landing-editor-desktop" element={<LandingEditorDesktop />}>
              {" "}
            </Route>
            <Route path="/fan-template" element={<FanTemplate />}>
              {" "}
            </Route>
            <Route path="/category-management" element={<CategoryManagement />}>
              {" "}
            </Route>
            <Route path="/info-message-management" element={<InfoMessage />}>
              {" "}
            </Route>
            <Route path="/user-management" element={<UserManagement />}>
              {" "}
            </Route>
            <Route path="/checklist-management" element={<ChecklistPage />}>
              {" "}
            </Route>
            <Route path="/badge-preview/:id" element={<BadgePreview />}>
              {" "}
            </Route>
            <Route path="/badge-edit/:id" element={<BadgeEdit />}>
              {" "}
            </Route>
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/key-management" element={<KeyManagement />} />
          </Route>
        }
        <Route path="/forgot-password" element={<ForgotPassword />} />

      </Routes>
    </div>
  );
}

export default App;
